import {
    mobileMenuButtonSx,
    muiAppBarSx,
    quickAccessButtonSx,
    toolbarSx
} from "./core/navigationStyles";
import {SkipLinks} from "../../fundamentals/SkipLinks";
import Logo from "./Logo";
import QuickAccessButton from "./QuickAccessButton";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import C091EasyLangContainer from "../../content/C091EasyLangTeaser/C091EasyLangContainer";
import useWindowSize from "../../../utility/useWindowSize";
import MobileMenu from "./MobileMenu/MobileMenu";
import {CmCollectionType, CmLinkableType} from "../../types";
import React, {useMemo, useState} from "react";
import {pageHeaderSx} from "../../page_layouts/pageLayoutsUtils";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";


interface EasyLangNavigationProps {
    navigation: any;
    header: any;
    page: any;
    topNavi?: React.ReactNode;
}

function EasyLangNavigation({
                                navigation,
                                header,
                                page,
                                topNavi
                            }: EasyLangNavigationProps) {
    const {
        lowerThanWindowSmall,
        lowerThanWindowLarge,
        greaterThanWindowLarge
    } = useWindowSize();
    const navigationRoot = navigation.content.site.root;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const topNaviItems = useMemo(() => {
        const topNavi = header?.items?.find(
            (cmCol: any) => cmCol.viewtype === "asTopNavi") as CmCollectionType;
        return (topNavi?.items ?? []).filter(item => item !== null) as CmLinkableType[];
    }, [header]);

    return <>
        <Box component="header" sx={pageHeaderSx}>
            {topNavi}
            <MuiAppBar component="div" sx={muiAppBarSx(lowerThanWindowSmall, greaterThanWindowLarge)}
                       position={"sticky"}>
                <SkipLinks isWithoutNavi isWithoutTopNavi={lowerThanWindowSmall}/>
                <Container maxWidth={false}
                           sx={{
                               display: "flex",
                               justifyContent: "center",
                               width: "100%",
                           }}>
                    <Toolbar disableGutters sx={toolbarSx}>
                        <Logo navigation={navigation}
                              portalHomeLink={navigationRoot?.easyLangToggleButton?.selfUrl}/>
                        <Box sx={quickAccessButtonSx}>
                            <QuickAccessButton fullWidth={false} page={page}/>
                        </Box>

                        {lowerThanWindowLarge && <Box
                            sx={{
                                display: {xs: "flex", lg: "none"},
                            }}
                        >
                            <IconButton
                                data-cypress={"mobileMenuButton"}
                                sx={mobileMenuButtonSx}
                                size="large"
                                aria-label="menu"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={() => setIsMenuOpen((prev) => !prev)}
                                color="inherit"
                            >
                                {isMenuOpen ?
                                    <CloseIcon data-cypress="mobileMenuCloseIcon"/> :
                                    <MenuIcon data-cypress="mobileMenuIcon"/>
                                }
                            </IconButton>
                            <MobileMenu
                                page={page}
                                items={navigationRoot.children}
                                open={isMenuOpen}
                                onClose={() => setIsMenuOpen(false)}
                                topNaviItems={topNaviItems}
                                navigation={navigation}
                                isEasyLangMode={true}
                            />
                        </Box>}
                    </Toolbar>
                </Container>
            </MuiAppBar>
        </Box>
        <div id="navigation" style={{background: "var(--background-grey)"}}>
            <C091EasyLangContainer navigationRoot={navigationRoot}/>
        </div>
    </>
}

export default EasyLangNavigation